/// <amd-module name="SuiteCommerce.Blog.DataProvider.Author.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.DataProvider.Author.Collection", ["require", "exports", "Backbone", "SuiteCommerce.Blog.DataProvider.Author.Model"], function (require, exports, Backbone_1, DataProvider_Author_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AuthorCollection = void 0;
    var AuthorCollection = /** @class */ (function (_super) {
        __extends(AuthorCollection, _super);
        function AuthorCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = DataProvider_Author_Model_1.AuthorModel;
            return _this;
        }
        AuthorCollection.prototype.getAuthorById = function (id) {
            return this.find(function (author) {
                return author.id === id;
            });
        };
        AuthorCollection.prototype.getAuthorByURLComponent = function (urlComponent) {
            return this.find(function (author) {
                return author.urlComponent === urlComponent;
            });
        };
        return AuthorCollection;
    }(Backbone_1.Collection));
    exports.AuthorCollection = AuthorCollection;
});
